import { DefaultCell } from "app/components/React/Table/cells";
import { NO_DATA_SIGN } from "app/filters/const";
import { getFinalTransitionParamsToKeywordDetailPage } from "app/pages/website-analysis/folders/utils";
import { allTrackers } from "app/services/track/track";
import { translate } from "app/filters/i18nFilter";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { SeeAll, TopKeywordsContainer, TotalKeywords } from "../StyledComponents";
import type { ITopPaidDataKeywords } from "../types";

const PLUS_SIGN = "+";

export const TopKeywordsCell = ({ topKeyword, totalKeywords, url }: ITopPaidDataKeywords) => {
    const onTotalKeywordsClick = () => {
        allTrackers.dispatchTrackEvent("Button", "click", "Top paid landing pages/See all keywords");
        void proNavigator.go(
            "organicsearch_websites_v2_traffic_keywords",
            getFinalTransitionParamsToKeywordDetailPage({
                keyValue: url,
                searchType: "exact",
                selectedPageTab: "Paid",
            }),
        );
    };

    if (!topKeyword && !totalKeywords) {
        return <DefaultCell value={NO_DATA_SIGN} />;
    }

    //

    return (
        <TopKeywordsContainer>
            <span>{topKeyword}</span>
            {totalKeywords ? (
                <TotalKeywords onClick={onTotalKeywordsClick}>
                    <span>{`(${PLUS_SIGN}${totalKeywords})`}</span>
                    <SeeAll>
                        {translate("website.analysis.search.overview.top.paid.landing.pages.keywords.cell.see.all")}
                    </SeeAll>
                </TotalKeywords>
            ) : null}
        </TopKeywordsContainer>
    );
};
